export default {
  inviteFriendReport: {
    total: "Total",
    depth: { root: "Top Friend", level: "Level {{level}} Friend" },
    scope: { root: "Whole Line", inviter: "Direct Friends (1 Level)", member: "Self" },
    scopeDirect: "Direct data",
    rowType: { context: "Top friend of this chain (context row)", hit: "Matched member" },
    filter: {
      account: "Account",
      tag: "Member Tag",
      tagPlaceholder: "e.g. Promoter",
      currency: "Currency",
      range: "Date Range",
      agent: "Agent",
      agentAll: "All",
      agentUnassigned: "Unassigned"
    },
    column: {
      member: "Member",
      scope: "Level / Scope",
      agentAccount: "Agent",
      date: "Date",
      inviteMemberCount: "Invited Members",
      directInviteCount: "Direct Invites",
      firstDepositMemberCount: "First Deposit Members",
      firstDepositAmount: "First Deposit Amount",
      depositTimes: "Deposit Count",
      depositAmount: "Deposit Amount",
      withdrawTimes: "Withdraw Count",
      withdrawAmount: "Withdraw Amount",
      validBetAmount: "Valid Bet",
      ggrAmount: "GGR",
      bonusAmount: "Bonus Claimed (incl. Commission)",
      commissionAmount: "of which: Invite Rebate",
      pointExchangeCash: "Points Redeemed to Cash",
      directFriend: "Direct Friend",
      selfDepositAmount: "Own Deposit Amount",
      selfWithdrawAmount: "Own Withdraw Amount",
      selfValidBetAmount: "Own Valid Bet",
      selfGgrAmount: "Own GGR",
      selfBonusAmount: "Own Bonus Claimed (incl. Rebate)",
      selfCommissionAmount: "Own Invite Rebate",
      selfPointExchangeCash: "Own Points Redeemed",
      trendInviteMember: "Invited Users",
      trendFirstDepositMember: "Invited First-Deposit Users",
      action: "Action"
    },
    action: { view: "View" },
    breadcrumb: { back: "Back to list", list: "Summary List" },
    composition: { rest: "Deeper Levels Subtotal (level 2+, not itemized)", total: "Total (= Whole Line = Metrics)" },
    analysis: {
      title: "Invite Analysis of {{account}}",
      directFriends: "Direct Friends (row = the friend's own data)",
      trendTitle: "Daily Trend ({{scope}})",
      trendHint: "Listed by day; the date range follows the filter above. The total row is the range total (for a week / month total, set the range to that week / month).",
      inviterScopeHint: "Excludes this member's own data"
    },
    tip: {
      needCurrencyAndRange: "Please select currency and date range first",
      searchMixed: "A non-top member matched: the row above is the top friend of the chain (whole line), the row below is that member's direct data. The two scopes cannot be summed, so the total is hidden."
    }
  },

  comprehensiveReport: {
    title: "Dashboard",
    profit: "Profit",
    profitRate: "Profit Rate",
    totalBet: "Total Bet",
    validBet: "Valid Bet",
    betUsers: "Bet Users",
    onlineUsers: "Online Users",
    onlineUsersTooltip: "Real-time online users, not affected by filters",
    gameProfitLoss: "Game Profit/Loss",
    memberBalance: "Member Balance",
    deposit: "Deposit",
    totalDeposit: "Total Deposit",
    withdrawal: "Withdrawal",
    totalWithdrawal: "Total Withdrawal",
    userStatistics: "User Statistics",
    bettingStatistics: "Betting Statistics",
    bettingOrders: "Betting Orders",
    monthlyComparison: "Monthly Comparison",
    thisMonthProfit: "This Month Profit",
    thisMonthProfitRate: "This Month Profit Rate",
    lastMonthProfit: "Last Month Profit",
    lastMonthProfitRate: "Last Month Profit Rate",
    registeredUsers: "Registered Users",
    firstDepositUsers: "First Deposit Users",
    secondDepositUsers: "Second Deposit Users",
    thirdDepositUsers: "Third Deposit Users",
    memberCount: "Member Count",
    users: "Users",
    depositTransactions: "Deposit Transactions",
    withdrawalTransactions: "Withdrawal Transactions",
    manualWithdrawal: "Manual Withdrawal",
    countedWithdrawal: "Counted Withdrawal",
    uncountedWithdrawal: "Uncounted Withdrawal",
    rejectedWithdrawal: "Rejected Withdrawal",
    totalPromo: "Total Promotions",
    paymentMethods: {
      bankCard: "Bank Card",
      gcash: "GCash",
      paymaya: "PAYmaya",
      manualDeposit: "Manual Deposit",
      countedDeposit: "Counted Deposit",
      uncountedDeposit: "Uncounted Deposit",
      promo1: "Promotion Bonus",
      promo2: "VIP Bonus",
      promo3: "Promo 3"
    },
    withdrawalMethods: {
      bankCard: "Bank Card",
      gcash: "GCash",
      paymaya: "PAYmaya"
    },
    vipWeeklySalary: "VIP Weekly Salary",
    vipMonthlySalary: "VIP Monthly Salary",
    vipBirthdayBonus: "VIP Birthday Bonus",
    vipUpgradePoints: "VIP Upgrade Points",
    vipRetentionPoints: "VIP Retention Points",
    vipAppDailyPoints: "VIP App Daily Points",
    vipH5DailyPoints: "VIP H5 Daily Points",
    vipUpgradeBonus: "VIP Upgrade Bonus",
    vipRetentionBonus: "VIP Retention Bonus",
    actManualBonus: "Manual Promotion Bonus",
    actRealtimeRebateBonus: "VIP Game Rebate Bonus",
    actRegisterBonus: "Registration Bonus",
    actRebateBonus: "Rebate Bonus",
    detail: "Details",
    amount: "Amount",
    search: "Search",
    reset: "Reset",
    today: "Today",
    yesterday: "Yesterday",
    startDate: "Start Date",
    endDate: "End Date",
    Manual: "Manual",
    Bank: "Bank",
    registerCount: "Register Count",
    depositCount: "Deposit Count",
    withdrawCount: "Withdraw Count",
    betCount: "Bet Count",
    firstDepositCount: "First Deposit Count",
    chart: "Chart",
    table: "Table",
    noData: "No Data",
    day: "Date",
    dataTip: "Note: (Current day statistics may be delayed by one hour. For other days, data is captured at 23:59:59 daily)",
    dateRangeExceeded: "Custom date range cannot exceed 31 days",
    pointExchange: "Point Exchange",
    cashExchange: "Cash Exchange",
    physicalExchange: "Physical Goods Exchange",
    toolExchange: "Virtual Item Exchange",
    exchangeMemberCount: "Members",
    exchangeQuantity: "Quantity",
    exchangeAmount: "Amount",
    exchangeTotal: "Total",
    adjustIncrease: "Adjustment Credit: Increase",
    adjustDecrease: "Adjustment Credit: Decrease",
    backendToAgentAdjust: "Backend Account to Agent Adjustment",
    agentAdjust: "Agent Adjustment",
    adjustTransactions: "Allocation Transactions"
  },
  regionChoropleth: {
    panelTitle: "Region Distribution ({country})",
    panelHint: "Click a region to locate it on the map",
    legendTitle: "Legend (Users)",
    countries: {
      PH: "Philippine Regions",
      VN: "Vietnam Regions",
    },
  },
  activeUserDistribution: {
    title: "Active User Panel",
    filters: {
      timeRange: "Time Range",
      timeRangeRequired: "Please select time range",
      currency: "Currency",
      currencyRequired: "Please select currency",
      currencyPlaceholder: "Select currency",
      countryAll: "All",
    },
    actions: {
      search: "Search",
      reset: "Reset",
    },
    cards: {
      dailyTrend: "Active User Trend",
      agentDistribution: "Active User Agent Distribution",
      deviceDistribution: "Active User Device Distribution",
      mobileProviderDistribution: "Active User Mobile Provider Distribution",
      depositDistribution: "Active User Deposit Distribution",
      regionDistribution: "Regional Distribution",
    },
    regionTable: {
      country: "Country",
      province: "Province",
      city: "City",
      total: "Users",
    },
    labels: {
      activeUserCount: "Active Users",
      noData: "No data",
      noRegionData: "No regional data",
      noCityData: "No city data",
      total: "Total Active Users",
      unknown: "Unknown",
      agentUnknown: "Agent Type {id}",
    },
    agentTypes: {
      official: "Official Website",
      agent: "Agent",
      adEntry: "Ad Entry",
      activity: "Activity",
    },
    devices: {
      all: "All",
      androidApp: "Android APP",
      androidPwa: "Android PWA",
      androidH5: "Android H5",
      iosApp: "IOS APP",
      iosPwa: "iOS PWA",
      iosH5: "iOS H5",
      web: "Web",
      others: "Others",
    },
    mobileProviders: {
      smart: "Smart",
      globe: "Globe",
      dito: "DITO",
    },
    depositStatus: {
      firstDeposit: "First Deposit",
      repeatDeposit: "Repeat Deposit",
      noDeposit: "No Deposit",
    },
    regionMap: {
      title: "Regional Distribution (PH Province Map)",
      provinceMapLabel: "Province Map",
      columns: {
        region: "Region",
        users: "Users",
      },
      summary: {
        coverage: "{count} regions reporting",
      },
    },
  },
  userRegisterDistribution: {
    title: "User Registration Dashboard",
    filters: {
      timeRange: "Registration Time",
      timeRangeRequired: "Please select registration time",
      agentType: "Agent Type",
      agentTypePlaceholder: "Select agent type",
      loginChannel: "Login Channel",
      loginChannelPlaceholder: "Select login channel",
      currency: "Currency",
      currencyPlaceholder: "Select currency",
      countryAll: "All",
      mobileProvider: "Mobile Carrier",
      mobileProviderPlaceholder: "Select mobile carrier",
      depositStatus: "Deposit Status",
      depositStatusPlaceholder: "Select deposit status"
    },
    actions: {
      search: "Search",
      reset: "Reset"
    },
    loginChannels: {
      all: "All",
      androidApp: "Android APP",
      androidPwa: "Android PWA",
      androidH5: "Android H5",
      iosApp: "IOS APP",
      iosPwa: "iOS PWA",
      iosH5: "iOS H5",
      web: "Web",
      others: "Others"
    },
    depositStatus: {
      all: "All Statuses",
      firstDeposit: "First Deposit Users",
      repeatDeposit: "Repeat Deposit Users",
      noDeposit: "Non-deposit Users"
    },
    cards: {
      dailyTrend: "Registration Trend",
      registerSource: "Registration Source Distribution",
      loginChannel: "Login Channel Distribution",
      depositStatus: "Deposit Status Distribution",
      mobileProvider: "Mobile Carrier Distribution",
      regionDistribution: "Regional Distribution"
    },
    regionTable: {
      country: "Country",
      province: "Province",
      city: "City",
      total: "Registered Users"
    },
    labels: {
      registerCount: "Registrations",
      noData: "No data",
      noRegionData: "No regional data",
      noCityData: "No city data",
      total: "Total Registrations",
      unknown: "Unknown",
      agentUnknown: "Agent Type {id}"
    },
    agentFallback: "Unknown Agent Type",
    fetchAgentFailed: "Failed to fetch agent type list",
    regionMap: {
      title: "Regional Heat Map",
      countryPlaceholder: "Select country",
      noData: "No map data",
      notSupported: "Map for this country is not supported",
      loadFailed: "Failed to load map data",
      loadFailedWithFallback: "Unable to download the map automatically. Please place a GeoJSON file at {fallback} or configure a reachable mirror.",
      accessDenied: "Map data request was denied. Please proxy the request or use another data source.",
      tooltipRegion: "Region",
      provinceMapLabel: "Province Map",
      columns: {
        region: "Region",
        users: "Registrations"
      },
      summary: {
        title: "Hotspot summary",
        total: "Total registrations",
        average: "Avg / province",
        peak: "Hottest region",
        low: "Coldest region",
        topRegions: "Top regions",
        coverage: "{count} provinces reporting"
      }
    }
  },
  betRecordReportList: {
    title: "Bet Record Query",
    prompt: "(Besides time filter, fill in at least one search condition)",
    memberAccount: "Member Account",
    orderNumber: "Order Number",
    betNumber: "Bet Number",
    betDetails: "Bet Details",
    payoutAmount: "Payout Amount",
    profitLossChange: "Profit/Loss Change",
    betSlipStatus: "Bet Slip Status",
    settlementVersion: "Settlement Version",
    repeatSettlement: "Repeat Settlement",
    transferBetSlip: "Transfer Bet Slip",
    gameName: "Game Name",
    gameCode: "Game Code",
    actions: "Actions",
    details: "Details",
    matchStartTime: "Match Start Time",
    isLive: "Is Live",
    leagueName: "League Name",
    betMarket: "Bet Market",
    betOdds: "Bet Odds",
    parlayType: "Parlay Type",
    settled: "Settled",
    unsettled: "Unsettled",
    yes: "Yes",
    no: "No",
    gameType: "Game Type",
    betTime: "Bet Time",
    settlementTime: "Settlement Time",
    settlementTimeFilter: "Settlement Time Filter",
    detailTitle: "Sports Bet Details",
    basicInfo: "Basic Information",
    betContent: "Bet Content",
    settlementHistory: "Settlement History",
    betSlipNumber: "Bet Slip Number",
    firstSettlementTime: "First Settlement Time",
    lastSettlementTime: "Last Settlement Time",
    memberProfitLoss: "Member Profit/Loss",
    jackpotContribution: "Jackpot Contribution",
    jackpotPayout: "Jackpot Payout",
    eventName: "Event Name",
    finalScore: "Final Score",
    singleItemStatus: "Single Item Status",
    settlementStatus: "Settlement Status",
    settlementCurrency: "Settlement Currency",
    profitLossAmount: "Profit/Loss Amount",
    settlementReason: "Settlement Reason",
    win: "Win",
    lose: "Lose",
    halfWin: "Half Win",
    halfLose: "Half Lose",
    push: "Push",
    cancelled: "Cancelled",
    pendingSettlement: "Pending Settlement",
    sportBetDetails: "Sports Bet Details",
    timeFilter: "Time Filter",
    dateRangeExceed32Days: "Date range cannot exceed 32 days",
    settleDateRangeExceed32Days: "Settlement date range cannot exceed 32 days",
    selectBetTime: "Please select bet time",
    loadDataFailed: "Failed to load data",
    collapse: "Collapse",
    expand: "Expand",
    parlayCount: "{count} Parlay"
  },
  betRecordHourlyList: {
    title: "Betting Record Report",
    prompt: "Previous day's data is processed at 4 AM",
    timeRange: "Time Range",
    timeRangeRequired: "Please select time range",
    memberAccount: "Member Account",
    exportWarning: "Please enter search criteria first",
    notes: "Notes:",
    note1: "Previous day's data is processed at 4 AM",
    note2: "Current day's betting data cannot be queried",
    note3: "Supports paginated data viewing, users can select number of entries per page"
  },

  gamePlatformReport: {
    date: "Date",
    statisticsDate: "Statistics Date",
    platformType: "Platform Type",
    platformName: "Platform Name",
    platformKey: "Platform Key",
    currency: "Currency",
    betUsers: "Bet Users",
    betOrders: "Bet Orders",
    betAmount: "Bet Amount",
    memberProfit: "Member Profit",
    platformProfit: "Platform Profit",
    killRate: "House Edge",
    killRateTooltip: "Platform Profit / Bet Amount",
    rtp: "RTP",
    rtpTooltip: "1 - House Edge",
    ggr: "GGR",
    ggrTooltip: "Bet Amount - Payout",
    total: "Total",
    subGameName: "Sub Game Name",
    enterPlatformName: "Enter Platform Name",
    enterPlatformKey: "Enter Platform Key",
    enterSubGameName: "Enter Sub Game Name",
    all: "All",
    today: "Today",
    yesterday: "Yesterday",
    thisWeek: "This Week",
    thisMonth: "This Month",
    lastMonth: "Last Month",
    last7Days: "Last 7 Days",
    last30Days: "Last 30 Days",
    totalRecords: "Total {total} records",
    search: "Search",
    reset: "Reset",
    noData: "No Data",
  },
  gameCodeReport: {
    title: "Sub Game Report",
    prompt: "Previous day's data is processed at 4 AM",
    memberAccount: "Member Account",
    orderNumber: "Order Number",
    statisticsDate: "Statistics Date",
    gameName: "Game Name",
    platformName: "Platform Name",
    platformKey: "Platform Key",
    currency: "Currency",
    betUsers: "Bet Users",
    betOrders: "Bet Orders",
    betAmount: "Bet Amount",
    memberProfit: "Member Profit",
    platformProfit: "Platform Profit",
    killRate: "House Edge",
    killRateTooltip: "Platform Profit / Bet Amount",
    rtp: "RTP",
    rtpTooltip: "1 - House Edge",
    ggr: "GGR",
    ggrTooltip: "Bet Amount - Payout",
    total: "Total",
    enterGameName: "Enter Game Name",
    enterPlatformName: "Enter Platform Name",
    enterPlatformKey: "Enter Platform Key",
    enterSubGameName: "Enter Sub Game Name",
    all: "All",
    today: "Today",
    yesterday: "Yesterday",
    thisWeek: "This Week",
    thisMonth: "This Month",
    lastMonth: "Last Month",
    last7Days: "Last 7 Days",
    last30Days: "Last 30 Days",
    totalRecords: "Total {total} records",
    search: "Search",
    reset: "Reset",
    noData: "No Data",
  },
  depositReport: {
    title: "Deposit Report",
    date: "Deposit Date",
    currency: "Currency",
    paymentChannel: "Payment Channel",
    totalOrders: "Total Orders",
    totalAmount: "Total Amount",
    totalSuccessOrders: "Total Success Orders",
    totalPaySuccessAmount: "Total Pay Success Amount",
    successRate: "Success Rate",
    thirdPartySuccessRate: "Third Party Success Rate",
    depositDate: "Deposit Date",
    selectPaymentChannel: "Please select payment channel",
    total: "Total",
    search: "Search",
    reset: "Reset",
    all: "All",
    totalRecords: "Total {total} records",
    noData: "No Data",
    dateRange: {
      today: "Today",
      yesterday: "Yesterday",
      thisWeek: "This Week",
      thisMonth: "This Month",
      lastMonth: "Last Month",
      last7Days: "Last 7 Days",
      last30Days: "Last 30 Days"
    }
  },
  agentBonusStats: {
    title: "Agent Bonus Report",
    dateRange: "Date Range",
    dateRangeRequired: "Please select a date range",
    dateRangeExceeds3Months: "Date range cannot exceed 3 months",
    cannotQueryCurrentDay: "Cannot query current day data",
    agentAccount: "Agent Account",
    agentAccountPlaceholder: "Please enter agent account",
    currency: "Currency",
    currencyPlaceholder: "Please select currency",
    bonusName: "Bonus Name",
    bonusNamePlaceholder: "Please enter bonus name",
    bonusType: "Bonus Type",
    bonusTypePlaceholder: "Please select bonus type",
    joinCount: "Participants",
    bonusAmount: "Distribution Amount",
    bonusPoint: "Distribution Points",
    day: "Date",
    cashTab: "Cash",
    pointsTab: "Points",
    agentName: "Agent Name",
    agentType: "Agent Type",
    level1Agent: "Level 1",
    directAgent: "Direct",
    level2Agent: "Level 2",
    summary: "Summary"
  },
  bonusRecordReport: {
    title: "Bonus Record Report",
    prompt: "Query bonus distribution records",
    dateRange: "Date Range",
    dateRangeRequired: "Please select a date range",
    dateRangeExceedsLimit: "Date range cannot exceed 7 days",
    dateRangeExceeds3Months: "Date range cannot exceed 3 months",
    dateRangeExceeds6Months: "Date range cannot exceed 6 months",
    cannotQueryCurrentDay: "Cannot query current day data",
    pleaseEnterMemberAccount: "Please enter member account",
    pleaseEnterSearchCriteria: "Please enter at least one search criterion",
    currency: "Currency",
    currencyPlaceholder: "Select currency",
    bonusName: "Bonus Name",
    bonusNamePlaceholder: "Enter bonus name",
    bonusType: "Bonus Type",
    bonusTypePlaceholder: "Select bonus type",
    "bonusType.monthlySalaryPoint": "Monthly Salary Points",
    "bonusType.weeklySalaryPoint": "Weekly Salary Points",
    "bonusType.birthdayPoint": "Birthday Points",
    joinCount: "Participation Count",
    bonusAmount: "Bonus Amount",
    bonusPoint: "Bonus Points",
    day: "Date",
    cashTab: "Cash",
    pointsTab: "Points",
    status: "Status",
    completed: "Completed",
    pending: "Pending",
    memberAccount: "Member Account",
    memberAccountPlaceholder: "Enter member account"
  },
  withdrawReport: {
    title: "Withdrawal Report",
    withdrawDate: "Withdrawal Date",
    currency: "Currency",
    withdrawChannel: "Withdrawal Channel",
    withdrawModel: "Withdrawal Method",
    serialNumber: "No.",
    totalWithdrawCount: "Total Withdrawal Count",
    totalWithdrawAmount: "Total Withdrawal Amount",
    withdrawFee: "Withdrawal Fee",
    successfulWithdrawCount: "Successful Withdrawal Count",
    successfulWithdrawAmount: "Successful Withdrawal Amount",
    withdrawSuccessRate: "Withdrawal Success Rate",
    manual: "Manual",
    all: "All",
    total: "Total",
    search: "Search",
    reset: "Reset",
    export: "Export",
    totalRecords: "Total {total} records",
    dateRangeRequired: "Please select date range",
    exporting: "Exporting, please wait...",
    exportSuccess: "Export successful",
    exportFailed: "Export failed",
    today: "Today",
    yesterday: "Yesterday",
    thisWeek: "This Week",
    thisMonth: "This Month",
    lastMonth: "Last Month",
    last7Days: "Last 7 Days",
    last30Days: "Last 30 Days"
  },
  registrationConversionReport: {
    title: "Registration & Conversion Report",
    dateRange: "Date Range",
    date: "Date",
    day: "Date",
    registerCount: "Registered Users",
    registerFirstDepositCount: "First Deposit Registrations",
    activeFirstDeposit: "Active First Deposits",
    registerFirstDepositRate: "First Deposit Conversion Rate",
    totalFirstDepositRate: "Total First Deposit Conversion Rate",
    retentionCount: "Retention Users",
    cumulativeDepositNumber: "Accumulated Recharge Count",
    cumulativeDepositAmount: "Accumulated Recharge Amount",
    search: "Query",
    reset: "Reset",
    export: "Export",
    noData: "No Data",
    isAppUser: "Please select if APP user",
    selectAppUser: "Please select",
    yes: "Yes",
    no: "No",
    all: "All",
    selectAgentType: "Select Agent Type",
    selectAgentTypePlaceholder: "Please select",
    firstLevelAgent: "First Level Agent",
    secondLevelAgent: "Second Level Agent",
    agentAccount: "Please enter agent account",
    enterAgentAccount: "Please enter agent account",
    agentTag: "Agent Tag",
    selectAgentTag: "Please select agent tag",
    query: "Query",
    report: "Report",
    chart: "Chart",
    conversionRateChart: "First Deposit Conversion Rate Chart",
    depositAmountChart: "Cumulative Deposit Amount Chart",
    noDataForChart: "No chart data available",
    selectTime: "Select Time",
    queryFailed: "Query Failed",
    exportSuccess: "Export Success",
    exportFailed: "Export Failed",
    items: "items",
    userStatistics: "Registration & Conversion Statistics",
    table: "Table",
    dataTip: "Data Tip",
    firstDepositCount: "Active First Deposits",
    firstDepositRate: "Total First Deposit Conversion Rate",
    coiledDepositCount: "Retention Users",
    officialDirect: "Official Direct",
  },
  valueStatsReport: {
    title: "Value Statistics Report",
    dateRange: "Date Range",
    date: "Date",
    registerCount: "Registration Count",
    depositCount: "Deposit Count",
    depositAmount: "Deposit Amount",
    withdrawAmount: "Withdrawal Amount",
    firstDayLtv: "First Day LTV",
    thirdDayLtv: "3 Day LTV",
    seventhDayLtv: "7 Day LTV",
    fifteenthDayLtv: "15 Day LTV",
    thirtiethDayLtv: "30 Day LTV",
    fortyFifthDayLtv: "45 Day LTV",
    sixtiethDayLtv: "60 Day LTV",
    seventyFifthDayLtv: "75 Day LTV",
    ninetiethDayLtv: "90 Day LTV",
    oneHundredFifthDayLtv: "105 Day LTV",
    oneHundredTwentiethDayLtv: "120 Day LTV",
    oneHundredThirtyFifthDayLtv: "135 Day LTV",
    oneHundredFiftiethDayLtv: "150 Day LTV",
    dailyArppu: "Daily ARPPU",
    search: "Query",
    reset: "Reset",
    export: "Export",
    noData: "No Data",
    isAppUser: "Please select if APP user",
    selectAppUser: "Please select",
    yes: "Yes",
    no: "No",
    all: "All",
    selectAgentType: "Select Agent Type",
    selectAgentTypePlaceholder: "Please select",
    firstLevelAgent: "First Level Agent",
    secondLevelAgent: "Second Level Agent",
    agentAccount: "Please enter agent account",
    enterAgentAccount: "Please enter agent account",
    agentTag: "Agent Tag",
    selectAgentTag: "Please select agent tag",
    query: "Query",
    report: "Report",
    chart: "Chart",
    selectTime: "Select Time",
    queryFailed: "Query Failed",
    exportSuccess: "Export Success",
    exportFailed: "Export Failed",
    selectCurrency: "Please select currency",
    items: "items",
    chartComingSoon: "Chart feature coming soon",
    officialDirect: "Official Direct"
  },
  keepStatsReport: {
    title: "Deposit Retention Report",
    dateRange: "Date Range",
    date: "Date",
    day: "Date",
    registerCount: "Registration Count",
    firstDepositCount: "Registered First Deposit Count",
    firstDepositRate: "Registered First Deposit Rate",
    registerFirstDepositCount: "Register First Deposit Count",
    totalFirstDepositRate: "Total First Deposit Rate",
    activeFirstDepositCount: "Active First Deposit Count",
    activeFirstDepositRate: "Active First Deposit Rate",
    coiledDepositCount: "Daily Redeposit Count",
    coiledDepositRate: "Same-day Redeposit Rate",
    firstDayRetention: "Day 1 Continue Deposit",
    firstDayRetentionTooltip: "Day 1 Continue Deposit Count/Rate",
    tomorrowKept: "Day 2 Retention",
    tomorrowKeptTooltip: "Day 2 Deposit Retention Count/Rate",
    tomorrowKeptRate: "Next Day Retention Rate",
    threeKept: "Day 3 Retention",
    threeKeptTooltip: "Day 3 Deposit Retention Count/Rate",
    threeKeptRate: "3 Day Retention Rate",
    fourKept: "Day 4 Retention",
    fourKeptTooltip: "Day 4 Deposit Retention Count/Rate",
    fourKeptRate: "4 Day Retention Rate",
    fiveKept: "Day 5 Retention",
    fiveKeptTooltip: "Day 5 Deposit Retention Count/Rate",
    fiveKeptRate: "5 Day Retention Rate",
    sixKept: "Day 6 Retention",
    sixKeptTooltip: "Day 6 Deposit Retention Count/Rate",
    sixKeptRate: "6 Day Retention Rate",
    sevenKept: "Day 7 Retention",
    sevenKeptTooltip: "Day 7 Deposit Retention Count/Rate",
    sevenKeptRate: "7 Day Retention Rate",
    fifteenKept: "Day 15 Retention",
    fifteenKeptTooltip: "Day 15 Deposit Retention Count/Rate",
    fifteenKeptRate: "15 Day Retention Rate",
    thirtyKept: "Day 30 Retention",
    thirtyKeptTooltip: "Day 30 Deposit Retention Count/Rate",
    thirtyKeptRate: "30 Day Retention Rate",
    thirtyCoiledDepositCount: "30 Day Redeposit Count",
    thirtyCoiledDepositRate: "30 Day Redeposit Rate",
    dailyCoiledDepositRate: "Daily Redeposit Rate",
    thirtyCoiledDepositDetail: "30 Day Redeposit Detail",
    search: "Query",
    reset: "Reset",
    export: "Export",
    noData: "No Data",
    isAppUser: "Please select if APP user",
    selectAppUser: "Please select",
    yes: "Yes",
    no: "No",
    all: "All",
    selectAgentType: "Select Agent Type",
    selectAgentTypePlaceholder: "Please select",
    firstLevelAgent: "First Level Agent",
    secondLevelAgent: "Second Level Agent",
    agentAccount: "Please enter agent account",
    enterAgentAccount: "Please enter agent account",
    agentTag: "Agent Tag",
    selectAgentTag: "Please select agent tag",
    query: "Query",
    selectTime: "Select Time",
    queryFailed: "Query Failed",
    exportSuccess: "Export Success",
    exportFailed: "Export Failed",
    selectCurrency: "Please select currency",
    items: "items",
    report: "Report",
    chart: "Chart",
    retentionChart: "Retention Data Chart",
    noDataForChart: "No chart data available",
    retentionCount: "Retention Count",
    userStatistics: "Retention Statistics",
    table: "Table",
    dataTip: "Data Tip",
    officialDirect: "Official Direct"
  },
  betKeepStatsReport: {
    title: "Betting Retention Report",
    dateRange: "Date Range",
    day: "Date",
    registerCount: "Registration Count",
    firstBetCount: "Registered First Bet Count",
    firstBetRate: "Registered First Bet Rate",
    delayFirstBetCount: "Active First Bet Count",
    totalFirstBetRate: "Total First Bet Rate",
    activeFirstBetRate: "Active First Bet Rate",
    thirtyRebetCount: "30-Day Re-bet Count",
    thirtyRebetCountTooltip: "Unique users who placed first bet and bet again within 30 days",
    thirtyRebetRate: "30-Day Re-bet Rate",
    thirtyRebetRateTooltip: "30-Day Re-bet Count / Registered First Bet Count",
    firstDayBet: "Day 1 Re-bet",
    firstDayBetTooltip: "D0 first-bet users who bet again on the same day",
    tomorrowBet: "Day 2 Betting",
    tomorrowBetTooltip: "First-bet users who bet the next day after registration (D1)",
    threeBet: "Day 3 Betting",
    threeBetTooltip: "Day 3 Betting Retention Count/Rate (D2)",
    fourBet: "Day 4 Betting",
    fourBetTooltip: "Day 4 Betting Retention Count/Rate (D3)",
    fiveBet: "Day 5 Betting",
    fiveBetTooltip: "Day 5 Betting Retention Count/Rate (D4)",
    sixBet: "Day 6 Betting",
    sixBetTooltip: "Day 6 Betting Retention Count/Rate (D5)",
    sevenBet: "Day 7 Betting",
    sevenBetTooltip: "Day 7 Betting Retention Count/Rate (D6)",
    fifteenBet: "Day 15 Betting",
    fifteenBetTooltip: "Day 15 Betting Retention Count/Rate (D14)",
    thirtyBet: "Day 30 Betting",
    thirtyBetTooltip: "Day 30 Betting Retention Count/Rate (D29)",
    isAppUser: "Please select if APP user",
    selectAppUser: "Please select",
    yes: "Yes",
    no: "No",
    all: "All",
    selectAgentType: "Select Agent Type",
    selectAgentTypePlaceholder: "Please select",
    agentAccount: "Agent Account",
    enterAgentAccount: "Please enter agent account",
    agentTag: "Agent Tag",
    selectAgentTag: "Please select agent tag",
    query: "Query",
    export: "Export",
    reset: "Reset",
    noData: "No Data",
    userStatistics: "Betting Retention Statistics",
    table: "Table",
    dateRangeExceeded: "Date range cannot exceed 31 days",
    officialDirect: "Official Direct",
    thirtyRebetDetail: "30-Day Re-bet Detail"
  },
  delayFirstDeposit: {
    title: "Delay First Deposit History",
    description: "Registration Date",
    memberAccount: "Member Account",
    registerTime: "Registration Time",
    firstDepositTime: "First Deposit Time",
    firstDepositAmount: "First Deposit Amount",
    agentAccount: "Agent Account",
  },
  overviewStatsReport: {
    title: "Overview Report",
    summary: "Overview Statistics",
    dateRange: "Date Range",
    date: "Date",
    day: "Date",
    loginCount: "Login Count",
    registerCount: "Registration Count",
    memberLoginCount: "Login Count",
    firstDepositCount: "First Deposit Count",
    firstDepositRate: "First Deposit Rate",
    depositAmount: "Total Deposit Amount",
    withdrawAmount: "Total Withdrawal Amount",
    profitAndLoss: "Deposit/Withdrawal P&L",
    registerFirstDepositCount: "Register First Deposit",
    activeFirstDepositCount: "Active First Deposit",
    registerFirstDepositRate: "Register First Deposit Rate",
    totalFirstDepositRate: "Total First Deposit Rate",
    tomorrowRetention: "Next Day Retention",
    sevenDayRetention: "7-Day Retention",
    thirtyDayRetention: "30-Day Retention",
    firstDayLTV: "LTV (First Day)",
    thirtyDayLTV: "LTV (30 Days)",
    search: "Search",
    reset: "Reset",
    report: "Report",
    chart: "Chart",
    overviewChart: "Overview Data Chart",
    noDataForChart: "No chart data available",
    queryFailed: "Query Failed",
    noData: "No Data",
    items: "items",
    export: "Export",
    exportSuccess: "Export Success",
    exportFailed: "Export Failed",
    isAppUser: "Please select if APP user",
    selectAppUser: "Please select",
    yes: "Yes",
    no: "No",
    all: "All",
    selectAgentType: "Select Agent Type",
    selectAgentTypePlaceholder: "Please select",
    firstLevelAgent: "First Level Agent",
    secondLevelAgent: "Second Level Agent",
    agentAccount: "Please enter agent account",
    enterAgentAccount: "Please enter agent account",
    agentTag: "Agent Tag",
    selectAgentTag: "Please select agent tag",
    query: "Query",
    selectTime: "Select time",
    selectCurrency: "Please select currency",
    userStatistics: "Overview Statistics",
    table: "Table",
    dataTip: "Data Tip",
    officialDirect: "Official Direct"
  },
  memberLoginLogReport: {
    title: "Member Login Log Report",
    dateRange: "Login Time",
    date: "Date",
    day: "Date",
    registerCount: "Registration Count",
    depositCount: "Deposit Count",
    loginIp: "Login IP",
    loginDeviceId: "Login device ID",
    ipLocation: "IP Location",
    loginMethod: "Login Method",
    loginChannel: "Login Channel",
    memberAccount: "Member Account",
    enterMemberAccount: "Please enter member account",
    enterLoginIp: "Please enter login IP",
    enterIpLocation: "Please enter IP location",
    enterLoginMethod: "Please enter login method",
    enterLoginChannel: "Please enter login channel",
    all: "All",
    loginDomain: "Login Domain",
    unknownLocation: "Unknown",
    loginChannels: {
      all: "All",
      others: "Others",
      web: "Web",
      androidApp: "Android APP",
      androidH5: "Android H5",
      androidPwa: "Android PWA",
      iosH5: "iOS H5",
      iosPwa: "iOS PWA",
      iosApp: "IOS APP"
    },
    loginMethods: {
      all: "All",
      password: "Username/Password",
      facebook: "Facebook",
      google: "Google",
      apple: "Apple"
    },
  },
  memberLoginLogSummary: {
    title: "Member Login Log Summary",
    dateRange: "Date Range",
    date: "Date",
    day: "Date",
    registerCount: "Registration Count",
    depositCount: "Deposit Count",
  },
  onlineUserPanel: {
    title: "Online User Panel",
    currentOnlineUsers: "Current Online Users",
    currentOnlineUsersDesc: "Statistics include: users who have logged in, entered the game page, entered the deposit/withdrawal page, or performed actions in the personal center within the last 30 minutes",
    realtimeOnlineChart: "Real-time Online Users (Three-day comparison for the same period)",
    mobileProviderDistribution: "Operator Distribution",
    deviceDistribution: "Device Distribution",
    regionDistribution: "Region Distribution",
    regionList: "Region Distribution",
    onlineUserList: "Online User List",
    labels: {
      unknown: "Unknown",
      noData: "No data",
      noCityData: "No city data",
    },
    actionTypes: {
      login: "Login",
      logout: "Logout",
      enterGame: "Enter Game",
      depositPage: "Deposit Page",
      withdrawPage: "Withdrawal Page",
      personalCenter: "Personal Center",
    },
    regionTable: {
      country: "Country",
      province: "Province",
      city: "City",
      total: "Users",
      all: "All",
    },
    table: {
      memberAccount: "Member Account",
      lastActionTime: "Last Activity Time",
      actionType: "Activity Type",
      deviceType: "Device Type",
      totalRecords: "Currently {total} records",
    },
  },
  payOrderStat: {
    title: "Recharge Dashboard",
    selectCurrency: "Select Currency",
    orderOverview: "Order Overview",
    rechargeAmount: "Recharge Amount",
    withdrawAmount: "Withdrawal Amount",
    payWithdrawDiff: "Recharge-Withdrawal Difference",
    statistics: "Statistics",
    totalPayCount: "Total Recharge Count",
    successRate: "Recharge Success Rate",
    avgPayTime: "Average Recharge Arrival Time",
    successCount: "Recharge Success",
    failedCount: "Recharge Failed",
    pendingCount: "Pending",
    channelTitle: "Recharge Method",
    selectChannel: "Select Recharge Method",
    channelTotalPayCount: "Total Recharge Count",
    channelAvgPayTime: "Average Recharge Arrival Time",
    channelSuccessCount: "Recharge Success",
    channelFailedCount: "Recharge Failed",
    channelPendingCount: "Pending",
    fetchFailed: "Failed to fetch recharge dashboard statistics",
    channelFetchFailed: "Failed to fetch recharge method dashboard statistics",
  },
  withdrawOrderStat: {
    title: "Withdrawal Dashboard",
    selectCurrency: "Select Currency",
    orderOverview: "Order Overview",
    rechargeAmount: "Recharge Amount",
    withdrawAmount: "Withdrawal Amount",
    payWithdrawDiff: "Recharge-Withdrawal Difference",
    statistics: "Statistics",
    totalWithdrawCount: "Total Withdrawal Count",
    successRate: "Withdrawal Success Rate",
    avgWithdrawTime: "Average Withdrawal Time",
    avgRiskCheckTime: "Average Review Time",
    avgRiskCheckTimeTooltip: "Manual Review Orders",
    successCount: "Disbursed",
    refusedCount: "Rejected",
    pendingPayoutCount: "Pending Disbursement",
    pendingReviewCount: "Pending Review",
    pendingReviewCountTooltip: "Manual Review Orders",
    channelTitle: "Withdrawal Method",
    selectChannel: "Select Withdrawal Method",
    channelTotalWithdrawCount: "Total Withdrawal Count",
    channelAvgWithdrawTime: "Average Withdrawal Time",
    channelAvgRiskCheckTime: "Average Review Time",
    channelSuccessCount: "Disbursed",
    channelRefusedCount: "Rejected",
    channelPendingPayoutCount: "Pending Disbursement",
    channelPendingReviewCount: "Pending Review",
    fetchFailed: "Failed to fetch withdrawal dashboard statistics",
    channelFetchFailed: "Failed to fetch withdrawal method dashboard statistics",
  },
  crossDayTransferSettlement: {
    title: "Cross-day Transfer Settlement Analysis Dashboard",
    keyIndicators: "Key Indicators",
    selectDate: "Select Date & Time",
    yesterdayUnsettledCount: "Yesterday Unsettled Bet Count",
    todayCompletedTransferCount: "Today Completed Transfer Settlement",
    todayRemainingUnsettledCount: "Today Remaining Unsettled Bets from Yesterday",
    todaySecondSettlementCount: "Today Transfer Bets with Second Settlement",
    profitLossChange: "Profit/Loss Change (Re-settlement)",
    repeatSettlementRatio: "Re-settlement Ratio",
  },
  jeepneyFunnelAnalysis: {
    title: "Jeepney Funnel Analysis",
    statisticsDate: "Statistics Date",
    dateSelect: "Select Date",
    fixedForToday: "Fixed for the day",
    dateRange: "Date Range",
    funnelChart: "Funnel Chart",
    funnelTable: "Funnel Table (By Event Chain)",
    metricCards: "Metric Cards",
    step: "Step",
    event: "Event",
    userCountUV: "Users (UV)",
    dimension: "Dimension",
    enterActivity: "Enter Activity Main Page",
    clickAdvance: "Click Advance (At least 1 time)",
    insufficientCurrency: "Trigger Insufficient Currency Block (At least 1 time)",
    openCurrencyPopup: "Open Currency Acquire Popup (At least 1 time)",
    completeCurrencyAcquire: "Complete Currency Acquire (At least 1 time)",
    reachFinalStage: "Reach Final Stage",
    settlementSuccess: "Settlement Success",
    settlementFailure: "Settlement Failure",
    settlementResult: "Settlement Result (Success/Failure)",
    activityParticipation: "Activity Participation",
    rechargeUsers: "Recharge Users",
    exchangeUsers: "Exchange Users",
    inviteValidFriends: "Invited Valid Friends",
    conversionRate: "Conversion Rate",
    noData: "No Data"
  }
};
